import { ApolloQueryResult } from '@apollo/client';
import gql from 'graphql-tag';
import { client } from '../../../containers/apollo';

export const CID_PHONE_MAP = gql`
  query getCidPhoneMap($input: GetCidPhoneMapInput!) {
    getCidPhoneMap(input: $input) 
  }
`;

export default async function getCidPhoneMap(
  cid: string,
): Promise<ApolloQueryResult<{ getCidPhoneMap: string | null }>> {
  return client.query({
    query: CID_PHONE_MAP,
    variables: { input: { cid } },
    fetchPolicy: 'no-cache',
  });
}
